module.exports = __webpack_public_path__ + "img/image1@3x.a26cd840.png";